import React from 'react';

const InfoCursussen = () => {
    return (
        <>
            <h1>Info Cursussen</h1>
        </>
    );
}

export default InfoCursussen;